import { render, staticRenderFns } from "./admin-contracts.vue?vue&type=template&id=0627a6c4&scoped=true"
import script from "./admin-contracts.vue?vue&type=script&lang=js"
export * from "./admin-contracts.vue?vue&type=script&lang=js"
import style0 from "./admin-contracts.vue?vue&type=style&index=0&id=0627a6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627a6c4",
  null
  
)

export default component.exports